import Home from './pages/Home.svelte';
import Employees from './pages/Employees.svelte';
import Login from './pages/Login.svelte';
import Reports from './pages/Reports.svelte';
import Admins from './pages/Admins.svelte';
import Profile from './pages/Profile.svelte';

const routes = {
  '/': Home,
  '/employees': Employees,

  '/login': Login,
  '/reports/:_id': Reports,

  '/admins': Admins,
  '/profile': Profile,

  // Using named parameters, with last being optional
  // '/author/:first/:last?': Author,

  // Wildcard parameter
  // '/book/*': Book,

  // Catch-all
  // This is optional, but if present it must be the last
  // '*': NotFound,
}

export default routes;